import CookiePolicyMain from './Main/CookiePolicyMain';

import styles from './styles.module.scss';

export default function CookiePolicy({ fields }) {
  return (
    <div>
      <h1 className={styles.title}>
        <b>{fields.title.value}</b>
      </h1>
      <CookiePolicyMain fields={fields} />
    </div>
  );
}
